import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  scannedImeiNo:"",
  locksessionId:"",
  mySelectedDevice: null,
  completeRegBTN: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, action) => {
      state.user = action.payload;
    },
    removeUser: (state, action) => {
      state.user = null;
    },
    SavescannedImeiNo: (state, action) => {
      state.scannedImeiNo = action.payload
    },
    settingLocksessionId: (state, action) => {
      state.locksessionId = action.payload
    },
    setMySelectedDevice : (state, action) => {
      state.mySelectedDevice = action.payload
    }, 
    setCompleteRegBTN: (state, action) => {
      state.completeRegBTN = action.payload
    },
  },
});

export default userSlice.reducer;
export const { saveUser, removeUser, SavescannedImeiNo, settingLocksessionId, setMySelectedDevice, setCompleteRegBTN } = userSlice.actions;
